import { call, put } from 'redux-saga/effects';
import { getCharges, getCharge, createCharge, updateCharge, deleteCharge, activateCharge, deactivateCharge } from '../requests/charges';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetCharges(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(getCharges);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(getCharge, action.payload.id);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleCreateCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(createCharge, action.payload.charge);
        yield put(showAlert({ severity: 'success', message: 'Charge created successfully' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(updateCharge, action.payload.id, action.payload.charge);
        yield put(showAlert({ severity: 'success', message: 'Charge updated successfully' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(deleteCharge, action.payload.id);
        yield put(showAlert({ severity: 'success', message: 'Charge deleted successfully' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleActivateCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(activateCharge, action.payload.id);
        yield put(showAlert({ severity: 'success', message: 'Charge activated successfully' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeactivateCharge(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(deactivateCharge, action.payload.id);
        yield put(showAlert({ severity: 'success', message: 'Charge deactivated successfully' }));
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}
